import mustache from 'mustache';

import Quantity from "./quantity";
import Buy1click from "./buy1click";

import './component.scss';

export class SaleBasketBasketPage {

    constructor(id, params, result, options) {
        this.id = id
        this.params = params
        this.result = result
        this.options = options
        this.$component = document.getElementById(this.id)

        if (this.$component.classList.contains('is-basket-inited')) {
            return;
        }

        this.$component.classList.add('is-basket-inited')

        this.init()
    }

    init() {
        this.initModules()
        this.render()
        this.addObservers()
    }

    render() {
        this.reRender()
        this.reInit()
        this.afterRendered()
    }

    reRender() {
        this.renderProductList()
        this.renderTotal()
        this.renderCoupons()
    }

    reInit() {
        this.reInitModules()
    }

    initModules() {
        this.quantity = new Quantity(this.id, this.params, this.result, this.options)
        this.buy1click = new Buy1click(this.id, this.params, this.result, this.options)
    }

    reInitModules() {
        this.quantity.reInit()
        this.buy1click.reInit()
    }

    afterRendered() {
        BX.onCustomEvent(window, 'sale.basket.basket.rendered')
    }

    fillResult(result) {
        for (let key in result.BASKET_DATA) {
            this.result[key] = result.BASKET_DATA[key]
        }
    }

    addObservers() {
        let self = this

        BX.addCustomEvent(window, 'OnQuantityChange', async function () {
            if (this.closest(`#${self.id}`)) {
                await self.changeItemQuantity(this.closest('.js-item'))
                BX.onCustomEvent(`OnBasketChange`)
            }
        })

        this.$component.on('click', '.js-basket-item-remove', async function (e) {
            await self.removeItem(this.closest('.js-item'))
            BX.onCustomEvent(`OnBasketChange`)
        })

        this.$component.on('submit', '.js-basket-coupon-form', async function (e) {
            e.preventDefault();
            await self.applyCoupon(self.$component.querySelector('.js-basket-coupon-input').value)
            BX.onCustomEvent(`OnBasketChange`)
        })

        this.$component.on('click', '.js-basket-coupon-remove', async function (e) {
            e.preventDefault();
            await self.removeCoupon(this.closest('.js-coupon').dataset.coupon)
            BX.onCustomEvent(`OnBasketChange`)
        })

        this.$component.on('click', '.js-basket-go-checkout', () => {
            window.location.href = self.params.PATH_TO_ORDER
        })
    }

    renderProductList() {
        let mustacheId = 'product-list',
            data = {
                show: true,
                items: Object.values(this.result.BASKET_ITEM_RENDER_DATA),
            }

        if (0 < data.items.length) {
            data.items = data.items.map(item => {
                let rewriteFields = {
                    PARAMS: {
                        show: 0 < item?.PARAMS?.length,
                        items: item.PARAMS,
                    },
                }

                return Object.assign({}, item, rewriteFields)
            })
        }

        this.renderMustache(`js-basket-${mustacheId}-template`, `js-basket-${mustacheId}-target`, data)
    }

    renderTotal() {
        let mustacheId = 'total',
            data = this.result.TOTAL_RENDER_DATA

        this.renderMustache(`js-basket-${mustacheId}-template`, `js-basket-${mustacheId}-target`, data)
    }

    renderCoupons() {
        if (0.0 === Number.parseFloat(this.result.TOTAL_RENDER_DATA.PRICE)) {
            return
        }

        let mustacheId = 'coupons',
            data = {
                show: 'Y' !== this.params.HIDE_COUPON,
                items: {
                    show: 0 < this.result.COUPON_LIST.length,
                    items: this.result.COUPON_LIST,
                },
            }

        this.renderMustache(`js-basket-${mustacheId}-template`, `js-basket-${mustacheId}-target`, data)
    }

    renderMustache(templateId, targetId, data) {
        let mixId = `${templateId}_${targetId}`,
            templateHtml = null,
            $target = null

        if (this.hasOwnProperty('mustacheCache') == false) {
            this.mustacheCache = {}
        }

        if (this.mustacheCache.hasOwnProperty(mixId)) {
            templateHtml = this.mustacheCache[mixId].templateHtml
            $target = this.mustacheCache[mixId].$target
        } else {
            let $template = document.getElementById(templateId)
            $target = document.getElementById(targetId)

            if (!$template || !$target) {
                return
            }

            templateHtml = $template.innerHTML

            this.mustacheCache[mixId] = {
                templateHtml: templateHtml,
                $target: $target
            }
        }

        let rendered = mustache.render(templateHtml, data)

        $target.innerHTML = rendered
    }

    async refresh() {
        const result = await this.query(this.params.AJAX_PATH, {})

        this.fillResult(result)
        this.reRender()
        this.reInit()
        this.afterRendered()
    }

    async changeItemQuantity(item) {
        let quantity = item.querySelector('.js-quantity-input').value,
            postFields = {
                [`basket[QUANTITY_${item.dataset.id}]`]: quantity,
                lastAppliedDiscounts: 1
            }

        const result = await this.query(postFields)

        this.fillResult(result)
        this.reRender()
        this.reInit()
        this.afterRendered()
    }

    async removeItem(item) {
        try {
            let postData = {
                [`basket[DELETE_${item.dataset.id}]`]: 'Y'
            }

            const result = await this.query(postData)

            if (
                (
                    !result.BASKET_DATA.BASKET_ITEM_RENDER_DATA
                    && !result.BASKET_DATA.BASKET_OUT_OF_STOCK_RENDER_DATA
                ) || (
                    result.BASKET_DATA.BASKET_ITEM_RENDER_DATA.length < 1
                    && result.BASKET_DATA.BASKET_OUT_OF_STOCK_RENDER_DATA.length < 1
                )
            ) {
                this.showPreloader()
                BX.reload()
            } else {
                this.fillResult(result)
                this.reRender()
                this.reInit()
                this.afterRendered()
            }
        } catch (error) {
            console.error(error)
        }
    }

    async applyCoupon(coupon) {
        this.lastQueryCoupon = true
        try {
            let postFields = {
                [`basket[coupon]`]: coupon
            }

            const result = await this.query(postFields)

            this.$component.querySelector('.js-basket-coupon-input').value = ''

            this.fillResult(result)
            this.reRender()
            this.reInit()
            this.afterRendered()
        } catch (error) {
            console.error(error)
        }
    }

    async removeCoupon(coupon) {
        try {
            let postFields = {
                [`basket[delete_coupon][${coupon}]`]: coupon
            }

            const result = await this.query(postFields)

            this.fillResult(result)
            this.reRender()
            this.reInit()
            this.afterRendered()
        } catch (error) {
            console.error(error)
        }
    }

    async query(data) {
        this.showPreloader()

        let resultData = undefined,
            obDefaultPostData = {
                [this.params.ACTION_VARIABLE]: 'recalculateAjax',
                via_ajax: 'Y',
                site_id: BX.message('SITE_ID'),
                site_template_id: this.options.siteTemplateId,
                sessid: BX.bitrix_sessid(),
                template: this.options.template,
                signedParamsString: this.options.signedParamsString
            },
            postData = Object.assign({}, data, obDefaultPostData)

        resultData = await Endorphine.Api.query(this.params.AJAX_PATH, postData)

        this.hidePreloader()

        return resultData
    }

    showPreloader() {
        BX.showWait(BX(this.id))
    }

    hidePreloader() {
        BX.closeWait(BX(this.id))
    }

}
